<template>
  <d2-container>
    <template slot="header">
      <el-input
        v-model="query.keyword"
        clearable
        size="small"
        placeholder="空间名称、编码或组织ID"
        style="width: 220px; margin-right: 8px"
        @keyup.enter.native="load"
      ></el-input>
      <el-select v-model="query.bound" clearable size="small" placeholder="关系状态" style="width: 120px; margin-right: 8px">
        <el-option label="已绑定" value="true"></el-option>
        <el-option label="客户模板" value="false"></el-option>
      </el-select>
      <el-select v-model="query.status" clearable size="small" placeholder="启用状态" style="width: 120px; margin-right: 8px">
        <el-option label="启用" :value="1"></el-option>
        <el-option label="停用" :value="0"></el-option>
      </el-select>
      <el-button type="primary" size="small" icon="el-icon-search" @click="load">搜索</el-button>
      <el-button type="success" size="small" icon="el-icon-connection" @click="openBind">直接绑定</el-button>
      <el-button size="small" icon="el-icon-message" :disabled="boundRelations.length === 0" @click="openInvite">邀请空间管理员</el-button>
    </template>

    <el-table :data="records" border stripe size="small" v-loading="loading">
      <el-table-column prop="id" label="空间ID" width="105"></el-table-column>
      <el-table-column label="服务方" min-width="190">
        <template slot-scope="scope">
          <span>{{ scope.row.internalOrgName || '-' }}</span>
          <small class="id-text">({{ scope.row.internalOrgId }})</small>
        </template>
      </el-table-column>
      <el-table-column label="客户组织" min-width="190">
        <template slot-scope="scope">
          <span>{{ scope.row.clientOrgName || '未绑定模板' }}</span>
          <small v-if="scope.row.clientOrgId" class="id-text">({{ scope.row.clientOrgId }})</small>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="空间名称" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="code" label="客户编码" width="130" show-overflow-tooltip></el-table-column>
      <el-table-column prop="managerAccountId" label="内部负责人" width="120"></el-table-column>
      <el-table-column label="关系状态" width="100" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.bound ? 'success' : 'info'">{{ scope.row.bound ? '已绑定' : '模板' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="启用状态" width="90" align="center">
        <template slot-scope="scope">
          <el-tag size="mini" :type="scope.row.status === 1 ? 'success' : 'info'">{{ scope.row.status === 1 ? '启用' : '停用' }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" width="170"></el-table-column>
      <el-table-column label="操作" width="150" fixed="right" align="center">
        <template slot-scope="scope">
          <el-button
            v-if="scope.row.bound && scope.row.status === 1"
            size="mini"
            type="primary"
            @click="openInvite(scope.row)"
          >邀请管理员</el-button>
        </template>
      </el-table-column>
    </el-table>

    <template slot="footer">
      <el-pagination
        :current-page.sync="query.currentPage"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSize"
        @current-change="handlePage"
      ></el-pagination>
    </template>

    <el-dialog title="直接绑定服务关系" :visible.sync="bindDialog" width="560px">
      <el-form ref="bindForm" :model="bindForm" label-width="125px">
        <el-form-item label="服务方组织" required>
          <organization-selector v-model="bindForm.internalOrgId" placeholder="选择已开启服务商能力的组织"></organization-selector>
        </el-form-item>
        <el-form-item label="客户组织" required>
          <organization-selector v-model="bindForm.clientOrgId" placeholder="选择要绑定的客户组织"></organization-selector>
        </el-form-item>
        <el-form-item label="模板空间ID">
          <el-input v-model="bindForm.templateServiceSpaceId" placeholder="留空使用服务方默认客户模板"></el-input>
        </el-form-item>
        <el-form-item label="内部负责人">
          <account-selector v-model="bindForm.managerAccountId" placeholder="留空继承模板负责人或组织所有者"></account-selector>
        </el-form-item>
        <el-form-item label="空间名称">
          <el-input v-model="bindForm.name" maxlength="128" placeholder="留空使用客户组织名称"></el-input>
        </el-form-item>
        <el-form-item label="客户编码">
          <el-input v-model="bindForm.code" maxlength="64" placeholder="留空继承模板编码"></el-input>
        </el-form-item>
      </el-form>
      <div class="form-tip">绑定会复制模板服务成员并初始化默认项目；重复绑定会直接返回已有关系。</div>
      <span slot="footer">
        <el-button @click="bindDialog = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitBind">确认绑定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="邀请空间管理员" :visible.sync="inviteDialog" width="560px">
      <el-form ref="inviteForm" :model="inviteForm" label-width="125px">
        <el-form-item label="客户服务空间" required>
          <el-select v-model="inviteForm.serviceSpaceId" filterable style="width: 100%" placeholder="选择已绑定的客户空间">
            <el-option
              v-for="item in boundRelations"
              :key="String(item.id)"
              :label="relationLabel(item)"
              :value="String(item.id)"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="有效期">
          <el-input-number v-model="inviteForm.validityDays" :min="1" :max="90" controls-position="right"></el-input-number>
          <span class="unit-text">天（接受后成为空间管理员）</span>
        </el-form-item>
      </el-form>
      <div class="form-tip">生成通用邀请链接，将链接发给对方即可；无需预先知道对方账号。</div>
      <span slot="footer">
        <el-button @click="inviteDialog = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitInvite">生成邀请</el-button>
      </span>
    </el-dialog>

    <el-dialog title="管理员邀请已生成" :visible.sync="inviteResultDialog" width="620px">
      <div class="invite-result">
        <div class="invite-result-icon"><i class="el-icon-check"></i></div>
        <h3>邀请链接已准备好</h3>
        <p>将下面的链接发送给受邀人。对方登录用户端并接受后，将自动切换到该客户空间并进入服务中心。</p>
        <el-input :value="inviteUrl" readonly>
          <el-button slot="append" icon="el-icon-document-copy" @click="copyInviteUrl">复制链接</el-button>
        </el-input>
        <div class="invite-result-meta">
          <span>角色：空间管理员</span>
          <span>有效期至：{{ createdInvitation.expireAt || '-' }}</span>
        </div>
      </div>
      <span slot="footer">
        <el-button @click="inviteResultDialog = false">关闭</el-button>
        <el-button type="primary" @click="openInviteUrl">在用户端打开</el-button>
      </span>
    </el-dialog>
  </d2-container>
</template>

<script>
import {
  getServiceRelations,
  bindServiceRelation,
  inviteServiceRelationAdmin
} from '@/api/ai/rights'
import OrganizationSelector from '@/components/ai-rights/OrganizationSelector.vue'
import AccountSelector from '@/components/ai-rights/AccountSelector.vue'

export default {
  name: 'aiClientServiceRelationManager',
  components: {
    OrganizationSelector,
    AccountSelector
  },
  data () {
    return {
      query: {
        currentPage: 1,
        pageSize: 20,
        keyword: '',
        bound: 'true',
        status: 1
      },
      records: [],
      total: 0,
      loading: false,
      submitting: false,
      bindDialog: false,
      inviteDialog: false,
      inviteResultDialog: false,
      inviteUrl: '',
      createdInvitation: {},
      bindForm: {},
      inviteForm: {
        serviceSpaceId: '',
        validityDays: 7
      }
    }
  },
  computed: {
    boundRelations () {
      return (this.records || []).filter(item => item && item.bound && item.status === 1)
    }
  },
  created () {
    this.load()
  },
  methods: {
    load () {
      this.loading = true
      getServiceRelations(this.query).then(res => {
        const page = res || {}
        this.records = page.records || []
        this.total = Number(page.total || 0)
      }).finally(() => {
        this.loading = false
      })
    },
    handleSize (size) {
      this.query.pageSize = size
      this.query.currentPage = 1
      this.load()
    },
    handlePage (page) {
      this.query.currentPage = page
      this.load()
    },
    openBind () {
      this.bindForm = {
        internalOrgId: '',
        clientOrgId: '',
        templateServiceSpaceId: '',
        managerAccountId: '',
        name: '',
        code: ''
      }
      this.bindDialog = true
    },
    openInvite (row) {
      this.inviteForm = {
        serviceSpaceId: row ? String(row.id) : '',
        validityDays: 7
      }
      this.inviteDialog = true
    },
    relationLabel (item) {
      if (!item) return ''
      return `${item.name || '客户服务空间'} / ${item.clientOrgName || item.clientOrgId || '-'} (ID:${item.id})`
    },
    normalizePayload (source) {
      const payload = Object.assign({}, source)
      Object.keys(payload).forEach(key => {
        if (payload[key] === '') payload[key] = null
      })
      return payload
    },
    submitBind () {
      if (!this.bindForm.internalOrgId || !this.bindForm.clientOrgId) {
        this.$message.warning('请选择服务方组织和客户组织')
        return
      }
      this.submitting = true
      bindServiceRelation(this.normalizePayload(this.bindForm)).then(() => {
        this.$message.success('服务关系绑定成功')
        this.bindDialog = false
        this.query.currentPage = 1
        this.load()
      }).finally(() => {
        this.submitting = false
      })
    },
    submitInvite () {
      if (!this.inviteForm.serviceSpaceId) {
        this.$message.warning('请选择客户服务空间')
        return
      }
      this.submitting = true
      inviteServiceRelationAdmin(this.normalizePayload(this.inviteForm)).then(res => {
        this.inviteDialog = false
        this.showInvitationResult(res)
      }).finally(() => {
        this.submitting = false
      })
    },
    showInvitationResult (invitation) {
      const token = invitation && invitation.token
      if (!token) {
        this.$message.success('管理员邀请已生成')
        return
      }
      const userAppBaseUrl = String(process.env.VUE_APP_USER_APP_URL || 'https://b.goticket.cn').replace(/\/+$/, '')
      this.createdInvitation = invitation
      this.inviteUrl = `${userAppBaseUrl}/#/organization/invite/${encodeURIComponent(token)}`
      this.inviteResultDialog = true
    },
    copyInviteUrl () {
      if (!this.inviteUrl) return
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(this.inviteUrl).then(() => {
          this.$message.success('邀请链接已复制')
        }).catch(() => this.fallbackCopyInviteUrl())
        return
      }
      this.fallbackCopyInviteUrl()
    },
    fallbackCopyInviteUrl () {
      const input = document.createElement('textarea')
      input.value = this.inviteUrl
      input.setAttribute('readonly', 'readonly')
      input.style.position = 'fixed'
      input.style.opacity = '0'
      document.body.appendChild(input)
      input.select()
      const copied = document.execCommand('copy')
      document.body.removeChild(input)
      this.$message[copied ? 'success' : 'warning'](copied ? '邀请链接已复制' : '复制失败，请手动复制')
    },
    openInviteUrl () {
      if (this.inviteUrl) window.open(this.inviteUrl, '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style scoped>
.id-text {
  margin-left: 4px;
  color: #909399;
}

.form-tip {
  margin: -4px 0 12px 125px;
  color: #909399;
  font-size: 12px;
  line-height: 20px;
}

.unit-text {
  margin-left: 8px;
  color: #909399;
}

.invite-result {
  padding: 4px 12px 10px;
  text-align: center;
}

.invite-result-icon {
  display: flex;
  width: 54px;
  height: 54px;
  align-items: center;
  justify-content: center;
  margin: 0 auto 14px;
  color: #fff;
  font-size: 26px;
  border-radius: 50%;
  background: #67c23a;
  box-shadow: 0 10px 24px rgba(103, 194, 58, 0.28);
}

.invite-result h3 {
  margin: 0;
  color: #303133;
  font-size: 20px;
}

.invite-result p {
  max-width: 480px;
  margin: 10px auto 18px;
  color: #606266;
  font-size: 13px;
  line-height: 1.7;
}

.invite-result-meta {
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  color: #909399;
  font-size: 12px;
}
</style>
